import { render, staticRenderFns } from "./real-time.vue?vue&type=template&id=94662aca&scoped=true"
import script from "./real-time.vue?vue&type=script&lang=js"
export * from "./real-time.vue?vue&type=script&lang=js"
import style0 from "./real-time.vue?vue&type=style&index=0&id=94662aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94662aca",
  null
  
)

export default component.exports